// removed by extract-text-webpack-plugin
module.exports = {"picker":"_1n5ENPSCwYDIebXXnRleUp","pick":"_3OZeYyaJbWhb9lDLSBOlzc"};


//////////////////
// WEBPACK FOOTER
// ./app/components/TaskPicker/style.scss
// module id = 1046
// module chunks = 0